import Theme from "./coras-nua-setup";

export default Theme;
